import { Utils } from 'versafleet-core';

const { request } = Utils.RequestHelper;

function requestSearch() {
  return {
    type: 'REQUEST_SEARCH',
  };
}

function receiveSearchResults(result) {
  return {
    type: 'RECEIVE_SEARCH_RESULTS',
    tasks: result.tasks,
    jobs: result.jobs,
  };
}

function resetSearchResults() {
  return {
    type: 'RESET_SEARCH_RESULTS',
  };
}

function search(keyword) {
  return (dispatch) => {
    request(`/search?keyword=${keyword}`, {
      method: 'GET',
    })
      .then((result) => {
        dispatch(receiveSearchResults(result));
        return result;
      });
  };
}

export default {
  search,
  requestSearch,
  resetSearchResults,
};
